// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_it-0";
export var fileCarousel = "_it-2";
export var removeFileButton = "_it-1";